/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { d as __spreadArray } from '../../../tslib.es6-e01eabb2.js';

/* 判断是否为base64字符串 */
var isBase64 = function (str) {
    if (typeof str === 'string' && str.length > 0) {
        try {
            window.atob(str);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    return false;
};
/* 判断是否支持直接分享（不唤起分享面板） */
var isSupportDirect = function (type) {
    return type === 'Weixin' || type === 'WeixinMoments';
};
var getShareType = function (options) {
    var title = options.title, content = options.content, url = options.url, image = options.image, _a = options._ext, _b = _a === void 0 ? {} : _a, _c = _b.cn, cn = _c === void 0 ? {} : _c;
    var _d = cn !== null && cn !== void 0 ? cn : {}, cnType = _d.type, cnWxMiniAppData = _d.wxMiniAppData;
    if (cnWxMiniAppData) {
        return 'wxminiapp';
    }
    if ((cnType === 'image' && image) ||
        (cnType === 'multimedia' && url) ||
        (cnType === 'text' && (title || content || url))) {
        return cnType;
    }
    /* 默认值multimedia（最常用的类型） */
    return 'multimedia';
};
/** 微信 渠道数据 */
var getWxMiniShareData = function (options, useImageBase64) {
    if (useImageBase64 === void 0) { useImageBase64 = false; }
    var title = options.title, content = options.content, image = options.image, _a = options._ext, _b = _a === void 0 ? {} : _a, _c = _b.cn, cn = _c === void 0 ? {} : _c;
    var cnWxMiniAppData = (cn !== null && cn !== void 0 ? cn : {}).wxMiniAppData;
    var _d = cnWxMiniAppData || {}, appId = _d.appId, path = _d.path, userName = _d.userName, wxEnv = _d.wxEnv;
    return [
        {
            name: 'Weixin',
            isDirect: true,
            param: {
                type: 'wxminiapp',
                text: title,
                imageURL: image,
                useImageBase64: useImageBase64,
                multimedia: {
                    title: title,
                    subTitle: content,
                    thumbnail: image,
                    wxMiniAppURL: "https://page.cainiao.com/mcn/ggpromo/applet.html?appId=".concat(appId),
                    wxMiniAppPath: path,
                    wxMiniAppUserName: userName,
                    wxEnv: wxEnv,
                },
            },
        },
    ];
};
/** web H5 渠道数据 */
var getBasicShareData = function (type, options, useImageBase64) {
    if (useImageBase64 === void 0) { useImageBase64 = false; }
    var title = options.title, content = options.content, url = options.url, image = options.image;
    var plainText = "".concat(title || '').concat(content || '').concat(url || '');
    var shareData = {
        SMS: {
            name: 'SMS',
            param: {
                text: plainText,
            },
        },
        Copy: {
            name: 'Copy',
            param: {
                text: plainText,
            },
        },
        Qzone: {
            name: 'Qzone',
            param: {
                type: 'multimedia',
                text: title,
                imageURL: image,
                useImageBase64: useImageBase64,
                multimedia: {
                    title: title,
                    subTitle: content,
                    thumbnail: image,
                    url: url,
                },
            },
        },
        DingTalk: {
            name: 'DingTalk',
            param: {
                type: 'multimedia',
                text: title,
                imageURL: image,
                useImageBase64: useImageBase64,
                multimedia: {
                    title: title,
                    subTitle: content,
                    thumbnail: image,
                    url: url,
                },
            },
        },
        Weibo: {
            name: 'Weibo',
            param: {
                type: 'image',
                imageURL: image,
                useImageBase64: useImageBase64,
                textForImageShare: plainText, // 微博分享图片可以给用户预填文字
            },
        },
        QQ: {
            name: 'QQ',
            param: {
                type: type,
                text: title,
                imageURL: image,
                useImageBase64: useImageBase64,
                multimedia: {
                    title: title,
                    subTitle: content,
                    thumbnail: image,
                    url: url,
                },
            },
        },
        Weixin: {
            name: 'Weixin',
            param: {
                useSquareThumbnail: true,
                type: type,
                text: title,
                imageURL: image,
                useImageBase64: useImageBase64,
                multimedia: {
                    title: title,
                    subTitle: content,
                    thumbnail: image,
                    url: url,
                },
            },
        },
        WeixinMoments: {
            name: 'WeixinMoments',
            param: {
                type: type,
                text: title,
                imageURL: image,
                useImageBase64: useImageBase64,
                multimedia: {
                    title: title,
                    subTitle: content,
                    thumbnail: image,
                    url: url,
                },
            },
        },
    };
    return shareData;
};
var getShareData = function (options, useImageBase64) {
    if (useImageBase64 === void 0) { useImageBase64 = false; }
    var title = options.title, content = options.content, url = options.url, image = options.image, _a = options._ext, _b = _a === void 0 ? {} : _a, _c = _b.cn, cn = _c === void 0 ? {} : _c;
    var _d = (cn !== null && cn !== void 0 ? cn : {}).channel, cnChannel = _d === void 0 ? [
        'SMS',
        'Copy',
        'Weixin',
        'WeixinMoments',
        'QQ',
        'Qzone',
        'DingTalk',
        'Weibo',
    ] : _d;
    var type = getShareType(options);
    /** 微信小程序分享 */
    if (type === 'wxminiapp') {
        return getWxMiniShareData(options, useImageBase64);
    }
    /* 检查参数，进行分享面板过滤 */
    var basicShareData = getBasicShareData(type, options, useImageBase64);
    var filterChannels = function (targetChannels) {
        return cnChannel
            .filter(function (channel) { return targetChannels.includes(channel); })
            .map(function (item) { return basicShareData[item]; });
    };
    var getPlainTextChannels = function () {
        if (!content && !url && !title) {
            return [];
        }
        return filterChannels(['Copy', 'SMS']);
    };
    var getPlainImageChannel = function () {
        if (!image) {
            return [];
        }
        return filterChannels(['Weibo']);
    };
    var getPlainMediaChannels = function () {
        if (!url) {
            return [];
        }
        return filterChannels(['Qzone', 'DingTalk']);
    };
    var getMixedChannel = function () {
        return filterChannels(['QQ', 'Weixin', 'WeixinMoments']);
    };
    var shareChannels = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], getPlainMediaChannels(), true), getPlainTextChannels(), true), getPlainImageChannel(), true), getMixedChannel(), true);
    /* 处理单渠道分享 */
    if (shareChannels.length === 1 && isSupportDirect(shareChannels[0].name)) {
        shareChannels[0].isDirect = true;
        return [shareChannels[0]];
    }
    return shareChannels;
};
/** 最终发送的数据 shareData */
var getShareParams = function (options) {
    var image = options.image;
    var useImageBase64 = isBase64(image);
    var shareData = getShareData(options, useImageBase64);
    var params = { shareData: shareData };
    // 处理base64格式图片
    if (useImageBase64) {
        params.imageBase64 = image === null || image === void 0 ? void 0 : image.split(',')[1];
    }
    return params;
};
// 菜鸟APP Hybrid ref：https://alidocs.dingtalk.com/i/nodes/Mk5evdR04jBV59vnPj1dVQL3x2OlParn
var showSharePanel = function (params, context) {
    var formatInput = function (options) {
        return getShareParams(options);
    };
    context.WVCall('CNHybridGGShareBoard.share', params, { formatInput: formatInput });
};

export { showSharePanel as default };
